import RestService from './RestService';

export default class Integrations extends RestService {
    constructor() {
        super(`/integrations`);
    }
}
